// Location: assets/bal-shelf.js
// What: Controls accessible store tabs with URL state and editor selection.
// Why: Keeps shelf navigation consistent across history and section reloads.
// RELEVANT FILES: sections/bal-shelf.liquid, assets/bal-shelf.css
(() => {
  if (customElements.get('bal-store-shelf')) return;
  class BalStoreShelf extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(tab, true), options);
        tab.addEventListener('keydown', event => {
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          const offsets = { ArrowRight: direction, ArrowLeft: -direction };
          let target;
          if (event.key in offsets) target = (index + offsets[event.key] + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.activate(this.tabs[target], true);
          this.tabs[target].focus();
        }, options);
      });
      const sync = () => {
        const tab = this.tabs.find(item => '#' + item.dataset.hash === location.hash);
        this.activate(tab || this.tabs[0], false);
      };
      window.addEventListener('hashchange', sync, options);
      window.addEventListener('popstate', sync, options);
      document.addEventListener('shopify:block:select', event => {
        const tab = this.tabs.find(item => item.dataset.blockId === event.detail?.blockId);
        if (tab) this.activate(tab, false);
      }, options);
      sync();
    }
    activate(tab, updateUrl) {
      if (!tab) return;
      this.tabs.forEach(item => {
        item.setAttribute('aria-selected', String(item === tab));
        item.tabIndex = item === tab ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      if (updateUrl && tab.dataset.hash && location.hash !== '#' + tab.dataset.hash) {
        history.pushState(null, '', '#' + tab.dataset.hash);
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('bal-store-shelf', BalStoreShelf);
})();
